import { useEffect, useState } from "react";
import _ from "lodash";
import { getKPIInfo } from "../../utils/API";
import { useNavigate } from "react-router";
import { convertToCommas, formatNumber } from "../../common/commonFunctions";
import { Typography } from "@mui/material";
import { appColor } from "../../common/constants";
import { Icon } from "@iconify/react";
import MuiAvatar from "@mui/material/Avatar";

function is_number(char: any) {
  {
    return !isNaN(parseInt(char));
  }
}

var myValueFormatter = (p: any) => {
  let is_n = is_number(p);
  if (is_n) {
    return formatNumber_q.format(p);
  }
};

const formatNumber_q = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

const KPIComponent = ({ ticker, cusip }: any) => {
  const navigate = useNavigate();
  const accountId = window.localStorage.getItem("activeAccountCode");
  let initialKpiInfo = {
    cusip: "",
    name: "",
    price: "",
    out: "",
    new: "",
    last: "",
    boxQty: "",
    segQty: "",
  };
  const [kpiInfo, setKpiInfo] = useState<any>({ ...initialKpiInfo });

  const getKPIData = async (request: any) => {
    try {
      let kpiResponse = await getKPIInfo(request);
      if (kpiResponse?.status === 200) {
        let kpiJson = await kpiResponse.json();
        if (kpiJson && kpiJson?.length > 0) {
          setKpiInfo({
            cusip: kpiJson[0]?.cusip,
            name: kpiJson[0]?.name,
            ticker: kpiJson[0]?.ticker,
            price: formatNumber.format(kpiJson[0]?.price),
            out: kpiJson[0]?.lp_rate_out
              ? kpiJson[0]?.lp_rate_out?.toFixed(3)
              : "",
            new: kpiJson[0]?.lp_rate_new
              ? kpiJson[0]?.lp_rate_new?.toFixed(3)
              : "",
            last: kpiJson[0]?.lp_rate_last
              ? kpiJson[0]?.lp_rate_last?.toFixed(3)
              : "",
            boxQty:kpiJson[0]?.box_qty,
            segQty: kpiJson[0]?.seg_qty,
          });
        } else {
          return { ...initialKpiInfo };
        }
      } else if (kpiResponse?.status === 401) {
        navigate("/signin");
      } else {
        return { ...initialKpiInfo };
      }
    } catch (err) {
      return { ...initialKpiInfo };
    }
  };

  useEffect(() => {
    if ((ticker && !_.isEmpty(ticker)) || (cusip && !_.isEmpty(cusip))) {
      let request = {
        function_code: "fn_rpt_sl_quote_ticker_cusip",
        function_param: { ticker_in: ticker, cusip_in: cusip, accountid:accountId },
      };
      getKPIData(request);
    } else setKpiInfo(initialKpiInfo);
  }, [ticker]);

  const renderKPI = (data: any) => {
    return (
      <>
        <div className="d-flex flex-row p-1 pb-0">
          <MuiAvatar sx={{ mr: 2, width: 30, height: 30 }}>
            <Icon icon={data?.icon} fontSize="0.8rem" color={appColor} />
          </MuiAvatar>
          <div className="d-flex flex-column">
            <div
              className="sl-quote-kpi-value"
              style={{ padding: "0rem 0rem" }}
            >
              <span>
                {data?.stats && !_.isNaN(data?.stats)
                  ? convertToCommas(data?.stats)
                  : 0}
              </span>
            </div>
            <div className="sl-quote-kpi-title">
              <span>{data?.title}</span>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="row w-100">
      {/* <div className="d-flex flex-column col me-1 w-50">
                <div><label className="me-1" style={{ color: "#943126" }}>Cusip: </label>{kpiInfo.cusip}</div>
                <div title={kpiInfo.name} style={{ whiteSpace: "nowrap", overflow: "hidden" }}><label className="me-1" style={{ color: "#943126" }}>Name: </label>{kpiInfo.name}</div>
                <div><label className="me-1" style={{ color: "#943126" }}>Price: </label>{kpiInfo.price}</div>
            </div>
            <div className="d-flex flex-column col me-1 w-25">
                <div><label className="me-1" style={{ color: "#198754" }}>LP Out: </label>{kpiInfo.out}</div>
                <div><label className="me-1" style={{ color: "#198754" }}>LP New: </label>{kpiInfo.new}</div>
                <div><label className="me-1" style={{ color: "#198754" }}>LP Last: </label>{kpiInfo.last}</div>
            </div>
            <div className="d-flex flex-column col w-25">
                <div><label className="me-1" style={{ color: "#0d6efd" }}>DTC Box: </label>{kpiInfo.boxQty}</div>
                <div><label className="me-1" style={{ color: "#0d6efd" }}>DTC Seg: </label>{kpiInfo.segQty}</div>
            </div> */}

      <div className="w-100 sx-md-overflow-x">
        <div
          className="d-flex flex-row justify-content-between ms-0 row"
          style={{
            backgroundColor: `#edf2f5`,
          }}
        >
          <div className="ps-2 col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-5 d-flex flex-row justify-content-start">
            <Typography color={appColor} fontSize={"0.9rem"} variant="h6">
              Name:
            </Typography>
            <Typography className="ms-2" fontSize={"0.9rem"}>
              {kpiInfo?.name ? kpiInfo?.name : ""} {"  "}
            </Typography>
          </div>
          <div className="ms-2 col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-4 d-flex flex-row justify-content-start">
            <Typography color={appColor} fontSize={"0.9rem"} variant="h6">
              Cusip:
            </Typography>
            <Typography className="ms-2" fontSize={"0.9rem"}>{`${
              kpiInfo?.cusip ? `${kpiInfo?.cusip}` : ""
            }`}</Typography>
          </div>
          <div className="ms-2 col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-4 d-flex flex-row justify-content-start">
            <Typography color={appColor} fontSize={"0.9rem"} variant="h6">
              Ticker:{" "}
            </Typography>
            <Typography className="ms-2" fontSize={"0.9rem"}>{`${
              kpiInfo?.ticker ? `${kpiInfo?.ticker}` : ""
            }`}</Typography>
          </div>
          <div className="ms-2 col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-4 d-flex flex-row justify-content-start">
            <Typography color={appColor} fontSize={"0.9rem"} variant="h6">
              Price:{" "}
            </Typography>
            <Typography className="ms-2" fontSize={"0.9rem"}>{`${
              kpiInfo.price ? `${kpiInfo.price}` : ""
            }`}</Typography>
          </div>
        </div>
        <div
          className="row ms-0"
          style={{
            paddingLeft: 0,
          }}
        >
          <div
            className="d-flex flex-row mb-0 justify-content-between"
            style={{ paddingLeft: 0 }}
          >
            <div className="d-flex flex-row justify-content-around">
                {renderKPI({icon:'iwwa:percentage', title:'LP Out', stats:kpiInfo.out})}
            </div>
            <div className="d-flex flex-row justify-content-around">
                {renderKPI({icon:'carbon:percentage', title:'LP New', stats:kpiInfo.new})}
            </div>
            <div className="d-flex flex-row justify-content-around">
                {renderKPI({icon:'fluent-mdl2:calculator-percentage', title:'LP Last', stats:kpiInfo.last})}
            </div>
            <div className="d-flex flex-row justify-content-around">
                {renderKPI({icon:'material-symbols:inventory-2-outline-rounded', title:'DTC Box', stats:kpiInfo.boxQty})}
            </div>
            <div className="d-flex flex-row justify-content-around">
                {renderKPI({icon:'ic:baseline-inventory', title:'DTC Seg', stats:kpiInfo.segQty})}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KPIComponent;
